import { kebabCase } from "lodash";

export interface LinkStyles {
  color?: string;
  fontSize?: string;
  fontStyle?: string;
  fontWeight?: string;
}

const DEFAULT_LINK_STYLES: LinkStyles = {
  color: "inherit",
  fontSize: "inherit",
  fontStyle: "inherit",
  fontWeight: "inherit",
};

export const getLinkStyles = (linkStyles: LinkStyles = {}): string => {
  const styles = {
    ...DEFAULT_LINK_STYLES,
    ...linkStyles,
  };

  return Object.entries(styles)
    .map(([key, value]) => `${kebabCase(key)}: ${value}`)
    .join("; ");
};
